enum WebserviceSignatureFields {
	ENABLED = "signature_enabled",
	INSTANCES = "signature_instances",
	QUEUE = "signature_queue",
	LATENCY = "signature_latency",
}

export default WebserviceSignatureFields;